import * as React from 'react';
import { Outlet } from 'react-router-dom';

import {
  ProvisionDemoContext,
  useProvisionDemoReducer,
} from '../contexts/reducer';

const ProvisionHeader: React.FC = () => {
  const [state, dispatch] = useProvisionDemoReducer();

  return (
    <ProvisionDemoContext.Provider value={{ state, dispatch }}>
      <Outlet />
    </ProvisionDemoContext.Provider>
  );
};

export default ProvisionHeader;
